/**
 * Utility functions for case-insensitive array operations
 */

/**
 * Checks if an array contains an element (case-insensitive)
 */
export const includesIgnoreCase = <T extends string>(array: T[], searchElement: T): boolean => {
  return array.some(item => item.toLowerCase() === searchElement.toLowerCase());
};

/**
 * Finds an element in an array (case-insensitive)
 */
export const findIgnoreCase = <T extends string>(array: T[], searchElement: T): T | undefined => {
  return array.find(item => item.toLowerCase() === searchElement.toLowerCase());
};

/**
 * Filters an array based on a case-insensitive search
 */
export const filterIgnoreCase = <T extends string>(array: T[], searchElement: T): T[] => {
  return array.filter(item => item.toLowerCase().includes(searchElement.toLowerCase()));
};

/**
 * Removes an element from an array (case-insensitive)
 */
export const removeIgnoreCase = <T extends string>(array: T[], searchElement: T): T[] => {
  return array.filter(item => item.toLowerCase() !== searchElement.toLowerCase());
}; 